import React from "react";

import { Chart } from "react-google-charts";
import { useQuery } from "@tanstack/react-query";
import { useTheme } from "../hooks/useTheme";
import { useHttp } from "../hooks/useHttp";
import LoadingCenter from "../components/LoadingCenter";

const LogsByAdmin = () => {
  const { theme } = useTheme();
  const request = useHttp();

  const bgColor = theme === "dark"
    ? "#323439"
    : "#FFFFFF";

  const textColor = theme === "dark"
    ? "#FFFFFF"
    : "#323439";

  const chartOptions = {
    title: "Logs por admin",
    width: "600",
    height: "400",
    titleTextStyle: {
      color: textColor
    },
    legend: {
      textStyle: {
        color: textColor
      }
    },
    animation: {
      startup: true,
      easing: "linear",
      duration: 1500,
    },
    vAxis: {
      textStyle: {
        color: textColor
      },
      titleTextStyle: {
        color: textColor
      }
    },
    hAxis: {
      textStyle: {
        color: textColor
      },
      titleTextStyle: {
        color: textColor
      }
    },
    backgroundColor: bgColor
  };

  const { data: chart, isLoading } = useQuery(["active-customers"], () => request({ url: "/dash/graph/1", method: "GET" }));

  if (isLoading) return <LoadingCenter />;

  return (
    <Chart
      chartType="PieChart"
      height="400px"
      data={chart?.data}
      options={chartOptions}
    />
  );
}

export default LogsByAdmin;